<template>
  <div>
    <Upload
      v-if="showSignUpload"
      class="upload-demo"
      ref="swFileUpload"
      :drag="showType === 'drag' && !disabledFile"
      :on-progress="fileUpload"
      :on-success="fileUpSuccess"
      :on-error="fileUpError"
      :on-preview="clickFile"
      :on-remove="fileRemove"
      :on-exceed="fileLengthExceed"
      :on-sign="handleSign"
      :disabled="disabledFile"
      :limit="length"
      :multiple="multiple"
      :headers="myHeaders"
      :action="fileAction"
      :file-list="fileList"
      :accept="getAllowableType"
      :before-upload="handleBeforeUpload"
    >
      <el-button
        v-if="showType === 'btn' && !disabledFile"
        slot="trigger"
        size="small"
        type="primary"
        >选取文件</el-button
      >
      <i v-if="showType === 'drag' && !disabledFile" class="el-icon-upload"></i>
      <div
        :title="showType === 'btn' ? html : ''"
        v-if="!disabledFile"
        class="el-upload__text"
        v-html="html"
      ></div>
      <div
        slot="tip"
        v-if="fileList.length && hideFileBatchDownloadBtn"
        style="text-align: right"
      >
        <el-button
          :loading="ziploading"
          type="text"
          class="el-upload__tip"
          @click="handleZIPDownload"
          >批量下载</el-button
        >
      </div>
    </Upload>
    <el-upload
      v-else
      class="upload-demo"
      ref="swFileUpload"
      :drag="showType === 'drag' && !disabledFile"
      :on-progress="fileUpload"
      :on-success="fileUpSuccess"
      :on-error="fileUpError"
      :on-preview="clickFile"
      :on-remove="fileRemove"
      :on-exceed="fileLengthExceed"
      :disabled="disabledFile"
      :limit="length"
      :multiple="multiple"
      :headers="myHeaders"
      :action="fileAction"
      :file-list="fileList"
      :accept="getAllowableType"
      :before-upload="handleBeforeUpload"
    >
      <el-button
        v-if="showType === 'btn' && !disabledFile"
        slot="trigger"
        size="small"
        type="primary"
        >选取文件</el-button
      >
      <i v-if="showType === 'drag' && !disabledFile" class="el-icon-upload"></i>
      <div
        :title="showType === 'btn' ? html : ''"
        v-if="!disabledFile"
        class="el-upload__text"
        v-html="html"
      ></div>
      <div
        slot="tip"
        v-if="fileList.length && hideFileBatchDownloadBtn"
        style="text-align: right"
      >
        <el-button
          :loading="ziploading"
          type="text"
          class="el-upload__tip"
          @click="handleZIPDownload"
          >批量下载</el-button
        >
      </div>
    </el-upload>
    <el-dialog
      class="downloadDialog"
      :title="file.name"
      :visible.sync="visible"
      width="30%"
      center=""
    >
      <div style="text-align: center">
        <!-- 普通下载和水印下载 -->
        <template v-if="widget.options.downloadType === 'allType'">
          <el-dropdown trigger="click" @command="downloadEvent">
            <el-button type="primary" icon="el-icon-download">
              下载<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="normal">附件下载</el-dropdown-item>
              <el-dropdown-item
                command="waterMark"
                :disabled="waterMarkDisabled"
                >水印附件下载</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </template>
        <!-- 水印下载 -->
        <template v-else-if="widget.options.downloadType === 'watermarkType'">
          <el-button
            type="primary"
            icon="el-icon-download"
            :disabled="waterMarkDisabled"
            @click="waterMarkDownload"
            >水印下载</el-button
          >
        </template>
        <!-- 普通下载 -->
        <template v-else>
          <el-button
            type="primary"
            icon="el-icon-download"
            @click="handleDownload"
            >下载</el-button
          >
        </template>

        <el-button
          v-if="hideFILEPreviewBtn"
          type="success"
          @click="handlePreview"
          icon="el-icon-tickets"
          >在线预览</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      :title="signObj.name"
      :visible.sync="signObj.visible"
      width="30%"
      center=""
      :show-close="true"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <div style="text-align: center">
        <div style="margin-bottom: 20px">确认签署完成吗？</div>
        <el-button icon="el-icon-edit" @click="handleSign(file)"
          >重新发起签署</el-button
        >
        <el-button
          type="primary"
          @click="handleSignComplete"
          icon="el-icon-check"
          >已完成签署</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import alertUtils from '../../../util/alertUtils'
import request2 from '@/util/request2.js'
import fileUtils from '../../../util/fileUtils'
import { encrypt } from '../../../util/crypto.js'
import formUtils from '../../../util/formUtils'
import { config } from '../../../config/config'
import { Base64 } from 'js-base64'
import request from '@/util/request.js'
import Upload from './upload'
import { generateUUID, getCurDate } from '@/util/index.js'
export default {
  name: 'sw-file',
  components: {
    Upload,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    appId: {
      type: String,
      default: '',
    },
    length: {
      type: Number,
      default: 8,
    },
    isDelete: {
      type: Boolean,
      default: false,
    },
    action: {
      type: String,
      default: '',
    },
    showType: {
      type: String,
      default: 'drag',
    },
    allowableType: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    widget: {
      type: Object,
      default: () => {},
    },
    instanceJson: {
      type: Object,
      default: () => {},
    },
    ffid: {
      type: String,
      default: '',
    },
    yyid: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      html: '将文件拖到此处，或<em>点击上传</em>',
      fileAction: this.action,
      applicationId: this.appId,
      disabledFile: this.disabled,
      fileList: this.value || [],
      myHeaders: {},
      visible: false,
      file: '',
      signObj: {
        name: '',
        visible: false,
      },
      ziploading: false,
      waterMarkDisabled: false,
    }
  },
  watch: {
    value: {
      handler(val) {
        this.fileList = val
      },
      deep: true,
      immediate: true,
    },
    disabled: {
      // 修复使用changeOptions方法设置文件组件是否禁用不生效
      handler(val) {
        this.disabledFile = val
      },
      immediate: true,
    },
  },
  created() {
    if (this.disabledFile) {
      this.html = '只读控件，无法上传'
    }
    const token = localStorage.getItem('Admin-Token')
    this.$set(this.myHeaders, 'X-Id-Token', token)
    const visitor = sessionStorage.getItem('visitor')
    this.$set(this.myHeaders, 'visitor', visitor)
    if (typeof this.applicationId !== 'undefined' && this.applicationId) {
      if (this.showType === 'btn') {
        this.html = '点击按钮,选取上传文件'
      }
      const dir = getCurDate()
      let allow = ''
      if (typeof this.allowableType !== 'undefined' && this.allowableType) {
        allow = this.getAllowableType
      }
      const timeStr = Date.now()
      this.$set(this.myHeaders, 'timeStr', timeStr)
      const fileType = encrypt(allow, 'formflow' + timeStr)
      this.fileAction =
        config.fileBaseAPI +
        this.fileAction +
        '?appId=' +
        this.applicationId +
        '&dir=' +
        dir +
        '&fileType=' +
        encodeURIComponent(fileType)
    } else {
      this.disabledFile = true
      this.html = '缺少应用ID，文件无法上传'
    }
  },
  computed: {
    justHandlePage() {
      if (location.pathname === '/handle') {
        return true
      }
      return false
    },
    showSignUpload() {
      return this.justHandlePage && this.widget.options.sign
    },
    adminToken() {
      const token = localStorage.getItem('Admin-Token')
      return token
    },
    hideFileBatchDownloadBtn() {
      if (process.env.VUE_APP_HIDE_FILE_DOWNLOAD_AND_PREVIEW_BTN_BY_YYID) {
        return (
          process.env.VUE_APP_HIDE_FILE_DOWNLOAD_AND_PREVIEW_BTN_BY_YYID.indexOf(
            this.yyid
          ) < 0
        )
      }
      return process.env.VUE_APP_HIDE_FILE_DOWNLOAD_BTN !== '1'
    },
    hideFILEPreviewBtn() {
      const yyid =
        process.env.VUE_APP_HIDE_FILE_DOWNLOAD_AND_PREVIEW_BTN_BY_YYID || ''
      if (
        yyid.indexOf('ENV_APP_HIDE_FILE_DOWNLOAD_AND_PREVIEW_BTN_BY_YYID') > -1
      ) {
        console.log(11)
        return true
      }
      if (yyid && yyid !== '') {
        console.log(yyid)
        console.log(this.yyid)
        return yyid.indexOf(this.yyid) < 0
      }
      return true
    },
    getAllowableType() {
      if (this.allowableType.indexOf('.') > -1) {
        return this.allowableType
      } else {
        let allow = ''
        const allowableTypeArr = this.allowableType.split(',')
        if (allowableTypeArr && allowableTypeArr.length > 0) {
          allowableTypeArr.map((item, index) => {
            allowableTypeArr[index] =
              index == allowableTypeArr.length - 1 ? `.${item}` : `.${item},`
          })
          allow = allowableTypeArr.join('')
        }
        return allow
      }
    },
  },
  methods: {
    handleBeforeUpload(file) {
      if (!this.widget.options.maxSize) {
        return true
      }
      const MB = 1024 * 1024
      if (file.size > this.widget.options.maxSize * MB) {
        alertUtils.alertWarning(
          `文件限制最大为${this.widget.options.maxSize}Mb,文件${
            file.name
          }约为${parseFloat(file.size / MB).toFixed(2)}Mb`,
          true
        )
        return false
      }
      return true
    },
    fileUpload() {
      // 文件上传
    },
    fileLengthExceed() {
      alertUtils.alertWarning('超过文件上传最大数', true)
    },
    fileUpSuccess(response, file, fileList) {
      // 文件上传成功
      if (
        response &&
        response.status === 200 &&
        response.data &&
        response.data.id
      ) {
        console.log('fileList', fileList)
        //等待所有文件都上传完成，这里注意fileList是所有的文件（包含已上传的）
        if (fileList.every(it => it.status == 'success')) {
          fileList.map(item => {
            //只push新上传的 （带有response）
            item.response &&
              this.fileList.push({
                url:
                  config.fileBaseAPI +
                  '/api/v1/file/service/file-upload/download?id=' +
                  item.response.data.id,
                id: item.response.data.id,
                appId: item.response.data.appId,
                sign: false,
                name: item.name,
                uid: item.uid,
                status: item.status,
                percentage: item.percentage,
                size: item.size,
              })
          })
          setTimeout(() => {
            console.log(' this.fileList', this.fileList)
            this.$emit('input', this.fileList)
          })
        }
        alertUtils.alertSuccess(response.message, true)
      } else {
        // 上传失败

        fileList.forEach((item, index) => {
          if (item.uid === file.uid) {
            fileList.splice(index, 1)
          }
        })
        alertUtils.alertError(response.message, true)
      }
    },
    fileUpError() {
      // 文件上传失败

      alertUtils.alertError('文件上传失败', true)
    },
    clickFile(file) {
      // 点击下载已上传文件
      const targetFile = this.fileList.find(item => {
        if (file.uid) {
          return item.uid === file.uid
        } else {
          return item.id === file.id
        }
      })
      if (targetFile) {
        this.file = targetFile
        this.visible = true

        let lastSpotIndex = this.file.name.lastIndexOf('.')
        let type = this.file.name.slice(lastSpotIndex + 1)
        console.log('type', type)
        if (type === 'pdf') {
          this.waterMarkDisabled = false
        } else {
          this.waterMarkDisabled = true
        }
      }
    },
    handlePreview() {
      console.log(this.file.name + '--' + this.file.url)
      const originUrl = this.file.url // 要预览文件的访问地址
      const previewUrl =
        originUrl +
        '&fullfilename=' +
        this.file.id +
        this.file.name +
        '&token=' +
        this.adminToken
      window.open(
        config.previewBaseApi +
          '?url=' +
          encodeURIComponent(Base64.encode(previewUrl))
      )
    },
    handleDownload() {
      if (this.file && this.file.url) {
        // fileUtils.fileDownload(null,file.url)
        window.location.href = this.file.url + '&token=' + this.adminToken
      } else {
        alertUtils.alertError('文件下载错误', true)
      }
    },
    waterMarkDownload() {
      if (this.file && this.file.url && this.instanceJson) {
        const data = {
          instanceJson: JSON.stringify(this.instanceJson),
          yyid: this.yyid,
          ffid: this.ffid,
          url: this.file.url,
          fileName: this.file.name,
        }
        request2({
          url: config.baseAPI + '/v1/minio/watermarkDownload',
          method: 'post',
          data,
          responseType: 'blob',
        }).then(response => {
          const blob = response.data
          if (!blob) {
            alertUtils.alertError('文件下载错误', true)
            return
          }
          console.log(blob instanceof Blob)
          const contentDisposition = response.headers['content-disposition']
          let filename = 'file'
          if (contentDisposition.indexOf('filename') > -1) {
            filename = contentDisposition.split('=')[1].trim()
            filename = JSON.parse(decodeURI(filename))
          }
          const url = window.URL.createObjectURL(blob)
          this.download(url, filename)
        })
      }
    },
    handleZIPDownload() {
      const data = { componentName: this.widget.name, items: this.fileList }
      this.fileZIPDownload(data)
    },
    fileZIPDownload(data) {
      this.ziploading = true
      request2({
        url: config.baseAPI + '/v1/file/zip/download',
        method: 'post',
        data: data,
        responseType: 'blob',
      })
        .then(res => {
          const blob = res.data
          if (!blob) {
            alertUtils.alertError('文件下载错误', true)
            return
          }
          const filename = this.widget.name + '.zip'

          const url = window.URL.createObjectURL(blob)
          this.download(url, filename)
        })
        .finally(() => {
          this.ziploading = false
        })
    },
    download(blobUrl, filename) {
      const a = document.createElement('a')
      a.style.display = 'none'
      a.download = filename
      a.href = blobUrl
      a.click()
    },
    fileRemove(file) {
      // 删除已上传文件
      if (file && file.id) {
        fileUtils.fileDeleted(file.id, this.fileList)
      }
    },
    async handleSign(file) {
      const targetFile = this.fileList.find(item => {
        return item.id === file.id
      })
      if (targetFile) {
        this.file = targetFile

        this.file.doc_number = generateUUID()
        const taskId = formUtils.getQueryVariable('taskid')
        const data = {
          fileName: this.file.name,
          fileUrl: this.file.url,
          moduleId: this.widget.model,
          taskId: taskId,
          docNumber: this.file.doc_number,
        }
        try {
          const res = await request({
            method: 'post',
            url: config.baseAPI + '/v1/twsmp/token',
            params: data,
          })
          const url = res.data.redirect_url + res.data.token
          window.open(url, '_blank')
        } catch (error) {
          this.$alert(error)
        }
        this.signObj.name = this.file.name
        this.signObj.visible = true
      }
    },
    async handleSignComplete() {
      try {
        const res = await request({
          method: 'get',
          url:
            config.baseAPI +
            '/v1/twsmp/querySinedByDocNumber?doc_number=' +
            this.file.doc_number +
            '&fileName=' +
            this.file.name,
        })
        if (res.flag === false) {
          throw new Error(res.msg)
        }
        this.fileList = this.fileList.map(v => {
          if (v.id === this.file.id) {
            v.url = res.data.upload_url
            v.sign = true
            this.file = v
          }
          return v
        })
        this.signObj.visible = false
      } catch (error) {
        this.$alert(error.message)
      }
    },
    downloadEvent(command) {
      if (command === 'normal') {
        this.handleDownload()
      } else if (command === 'waterMark') {
        this.waterMarkDownload()
      }
    },
  },
}
</script>
<style lang="scss">
.downloadDialog {
  .el-dropdown {
    margin-right: 10px;
    .el-button--primary {
      background-color: #0e6ccb;
    }
  }
  .el-button--primary {
    background-color: #0e6ccb;
  }
}
</style>
